export  const inAuthority = (menu:any, key:any) => {
  let routepermission = [];
  try {
    const storageData = localStorage.getItem('routepermission');
    if (storageData) {
      routepermission = JSON.parse(storageData);
    }
  } catch (e) {
    routepermission = [];
  }
  if (!Array.isArray(routepermission)) return false;

  const parentItem = routepermission.find(item => item.code === menu);
  // 无匹配一级项，直接返回false
  if (!parentItem) return false;

  const children = parentItem.children;
  if (!Array.isArray(children)) return false;

  const hasAuthorized = children.some(child => {
    return child.code.includes(key) && child.checked === true;
  });
  return hasAuthorized;
}